<template>
  <div
    class="d-flex i-ml-8 align-items-center"
    data-testid="credit-insights-reconciled-docs-filter"
  >
    <i-switch
      id="credit_insights_reconciled_docs_filter_switch"
      data-testid="credit_insights_reconciled_docs_filter_switch"
      label="High confidence docs only"
      description=""
      :disabled="false"
      :value="excludeUnreconciledDocs"
      size="sm"
      type="primary"
      @input="toggleRule"
    />
    <i-tooltip
      title="High confidence docs only"
      target="#credit_insights_reconciled_docs_filter_switch"
      description="Toggle to exclude bank statements with low parsing confidence, thereby enhancing the reliability of the displayed Credit Insights."
      :alignment="iTooltipAlignmentMode.BOTTOM_MIDDLE"
    ></i-tooltip>
  </div>
</template>

<script>
import { iSwitch, iTooltip, iTooltipAlignmentMode } from '@inscribe/signal';
import { updateQueryParams, getAndSyncQueryParams } from '@/utils/queryParams';
import { getUseAllDocsQueryParameter } from '@/V2/credit/utils';

export default {
  name: 'CreditInsightsReconciledDocsFilter',
  components: {
    iSwitch,
    iTooltip,
  },
  data() {
    return {
      iTooltipAlignmentMode,
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
    };
  },
  computed: {
    includeUnreconciledDocs() {
      return getUseAllDocsQueryParameter(this.params);
    },
    excludeUnreconciledDocs() {
      return !this.includeUnreconciledDocs;
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        const oldUseAllDocsValue = this.params?.use_all_docs;
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
        if (oldUseAllDocsValue !== this.params?.use_all_docs) {
          this.updateIncludeDocsQueryParameter(this.includeUnreconciledDocs);
        }
      },
    },
  },
  mounted() {
    this.updateIncludeDocsQueryParameter(this.includeUnreconciledDocs);
  },
  methods: {
    toggleRule(excludeUnreconciledDocs) {
      const useAllDocs = !excludeUnreconciledDocs;
      this.updateIncludeDocsQueryParameter(useAllDocs);
    },
    updateIncludeDocsQueryParameter(useAllDocs) {
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          use_all_docs: useAllDocs,
        },
      });
    },
  },
};
</script>
